import { useState, useEffect } from "react";
import { useAsync } from "./useAsync";

export const useEdit = (asyncFunction, immediate = true, defaultValue) => {
    const [status, setStatus] = useState("idle");
    const [value, setValue] = useState(defaultValue ? defaultValue : null);
    const [error, setError] = useState(null);

    const [execute, asyncStatus, data, asyncError] = useAsync(
        asyncFunction,
        immediate
    );
    useEffect(() => {
        try {
            setStatus(asyncStatus);
            if (asyncStatus === "success") setValue(data);
            if (asyncStatus === "error") setError(asyncError);
        } catch (err) {
            setValue(null);
            setStatus("error");
            setError(`An error: ${err}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [asyncStatus]);
    return [execute, status, value, error];
};
